<template functional>
  <div>
    <a
      v-if="props.rowValue > 0"
      href="#"
      @click="$options.show(props)"
      :class="[$options.ColorRegistrosConErrores(props, props.column)]"
    >
      <!-- {{ $options.prueba() }} -->
      {{ props.rowValue }}
    </a>
  </div>
</template>

<script>
export default {
  name: "NewHyperLink",

  ColorRegistrosConErrores(ops, mes) {
    if (ops.row.emitidos != null) {
      if (ops.row.emitidos[mes] > 0) {
        return "Rojo";
      } else return "Azul";
    }

    //  console.log("ColorRegistrosConErrores: ",ops.row.emitidos[mes])

    //  if(mes == .mes)
    //  const {emitidos}=ops.row;

    //  if(mes == emitidos)
    // console.log(emitidos)
    // if (mes == "Marzo") {
    //   if (ops.row.emitidos.Marzo > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // }
    // if (mes == "Enero") {
    //   if (ops.row.emitidos.Enero > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Febrero") {
    //   if (ops.row.emitidos.Febrero > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Abril") {
    //   if (ops.row.emitidos.Abril > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Mayo") {
    //   if (ops.row.emitidos.Mayo > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Junio") {
    //   if (ops.row.emitidos.Junio > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Julio") {
    //   if (ops.row.emitidos.Julio > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Agosto") {
    //   if (ops.row.emitidos.Agosto > 0) {
    //     return "Rojo";
    //   } else {
    //     return "Azul";
    //   }
    // } else if (mes == "Septiembre") {

    //   if (ops.row.emitidos.Septiembre > 0) {
    //     return "Rojo";
    //   } else return "Azul";
    // } else if (mes == "Octubre") {
    //   if (ops.row.emitidos.Octubre > 0) {
    //     return "Rojo";
    //   } else return "Azul";
    // } else if (mes == "Noviembre") {
    //   if (ops.row.emitidos.Noviembre > 0) {
    //     return "Rojo";
    //   } else return "Azul";
    // } else if (mes == "Diciembre") {
    //   if (ops.row.emitidos.Diciembre > 0) {
    //     return "Rojo";
    //   } else return "Azul";
    //}

    // console.log(ops);
    // console.log(ops.row.emitidos.mes);
    // console.log(mes);
  },
  //   async prueba(ops) {
  //     let respuesta = 0;

  //     if(ops){
  //     //   await  ops.row.thiss.get(`/api/tennos/GetCountOfEmiTransaction?year=${ops.row.year}&month=${ops.mes}`)
  //     // .then((resp) => {
  //     //     respuesta= resp.data;
  //     //     console.log(respuesta)
  //     //     // console.log(month + 'e'+respuesta);

  //     //   });
  //     // let variable = 0;
  //        await checkTransactions(ops.mes,ops.row.year,ops.row.thiss).then((x)=>{ console.log(x);if(x>0) { respuesta = x}})

  //     }
  //     return respuesta;
  //     // if (ops.mes.length > 0) {
  //     //   console.log(ops.mes);
  //     //   // console.log(ops.row.mes)
  //     //   this.checkTransactions();
  //     //   this.loading = false;

  //     //   return `azul`;
  //     // }
  //   },

  show(ops) {
    ops.row.OpenDetailsDrawer(ops.mes, ops.row.descripcion, ops.rowValue);
  }
};
</script>

<style>
.Rojo {
  color: #c71d10;
}
.Azul {
  color: blue;
}
</style>
